export const handleMondayError = (error: object) => {
  if (error.hasOwnProperty("error_message") || error.hasOwnProperty("error_code") || error.hasOwnProperty("errors")) {
    throw new Error(JSON.stringify(error, null, 2));
  }
};
